<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text">
    {{ isEditMode ? "Edit Site" : "Add Site" }}
  </div>
  <button mat-icon-button class="close-btn" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <form [formGroup]="siteForm" (ngSubmit)="onSubmit()" class="form-grid">
    <div class="form-grid-row">
      <!-- Site Name -->
      <mat-form-field appearance="outline">
        <mat-label>Site Name</mat-label>
        <input matInput
              formControlName="siteName"
              required
              data-testId="siteName" maxlength="50"/>
      </mat-form-field>

      <!-- Site Type -->
      <mat-form-field appearance="outline">
        <mat-label>Site Type</mat-label>
        <mat-select formControlName="siteType" required>
          <mat-option [value]="null">-Select Site Type-</mat-option>
          <mat-option *ngFor="let type of siteTypes" [value]="type.id">
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- Address Line 1 -->
      <mat-form-field appearance="outline">
        <mat-label>Address Line 1</mat-label>
        <input matInput
                formControlName="address1"
                required
                data-testId="address1" maxlength="100" />
      </mat-form-field>

      <!-- Address Line 2 -->
      <mat-form-field appearance="outline">
        <mat-label>Address Line 2</mat-label>
        <input matInput formControlName="address2" data-testId="address2" maxlength="100"/>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
        <!-- State -->
        <mat-form-field appearance="outline">
          <mat-label>State</mat-label>
          <mat-select formControlName="state"
                      required
                      data-testId="state"
                      (selectionChange)="onStateChanged($event.value)">
            <div class="mat-select-search-container" (click)="$event.stopPropagation()">
              <input #stateSearchInput matInput placeholder="Search State..." (input)="filterState($event)"
                      class="mat-select-search-input" aria-label="Search State" (keydown)="$event.stopPropagation();" />
              <mat-icon class="mat-select-search-icon">search</mat-icon>
            </div>
            <mat-option [value]="null">-Select State-</mat-option>
            @for (state of filteredStates; track state.id) {
            <mat-option [value]="state.state">{{ state.state }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <!-- City -->
        <mat-form-field appearance="outline">
          <mat-label>City</mat-label>
          <mat-select formControlName="city" required data-testId="city">
            <div class="mat-select-search-container" (click)="$event.stopPropagation()">
              <input #citySearchInput matInput placeholder="Search City..." (input)="filterCity($event)"
                      class="mat-select-search-input" aria-label="Search City" (keydown)="$event.stopPropagation();" />
              <mat-icon class="mat-select-search-icon">search</mat-icon>
            </div>
            <mat-option [value]="null">-Select City-</mat-option>
            @for (city of filteredCities; track city.id) {
            <mat-option [value]="city.city">{{ city.city }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
    </div>
    <div class="form-grid-row">
        <!-- Zip Code -->
        <mat-form-field appearance="outline">
          <mat-label>Zip Code</mat-label>
          <input matInput formControlName="zipCode" data-testId="zipCode" maxlength="10"/>
        </mat-form-field>
        
        <mat-form-field appearance="outline">
          <mat-label>Market</mat-label>
          <mat-select formControlName="regions" data-testId="regions">
            <div class="mat-select-search-container" (click)="$event.stopPropagation()">
              <input #mktSearchInput matInput placeholder="Search Market..." (input)="filterMarket($event)"
                class="mat-select-search-input" aria-label="Search Market" (keydown)="$event.stopPropagation();" />
              <mat-icon class="mat-select-search-icon">search</mat-icon>
            </div>
            <mat-option [value]="null">-Select Market-</mat-option>
            @for (market of markets; track market.id) {
            <mat-option [value]="market.id">{{ market.regionName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-slide-toggle data-testid="isRevenue" name="isRevenue"
        formControlName="isRevenue" color="primary" labelPosition="before">
        <span class="font-medium text-gray-700 w-44 inline-block">Is Revenue</span>
      </mat-slide-toggle>
      <mat-slide-toggle data-testid="isActive" name="isActive"
        formControlName="isActive" color="primary" labelPosition="before">
        <span class="font-medium text-gray-700 w-44 inline-block">Is Active</span>
      </mat-slide-toggle>
    </div>
    <div class="form-grid-row">
        <!-- Contact Name -->
        <mat-form-field appearance="outline">
          <mat-label>Contact Name</mat-label>
          <input matInput
                formControlName="contactName"
                data-testId="contactName" maxlength="100"/>
        </mat-form-field>

        <!-- Contact Number -->
        <mat-form-field appearance="outline">
          <mat-label>Contact Number</mat-label>
          <input matInput 
                formControlName="contactNumber"
                data-testId="contactNumber"
                (input)="formatPhoneNumber($event)" />
          <!-- <mat-error *ngIf="siteForm.get('contactNumber')?.hasError('pattern')">
            Enter a valid US contact number
          </mat-error> -->
        </mat-form-field>
    </div>
    <div class="form-grid-row">
        <!-- Contact Email -->
        <mat-form-field appearance="outline">
          <mat-label>Contact Email</mat-label>
          <input matInput
                formControlName="contactEmail"
                data-testId="contactEmail" maxlength="100"/>
          <!-- <mat-error *ngIf="siteForm.get('contactEmail')?.hasError('email')">
            Enter a valid email
          </mat-error> -->
        </mat-form-field>

        <!-- Disposal Method -->
        <mat-form-field appearance="outline">
          <mat-label>Disposal Method</mat-label>
          <mat-select formControlName="disposalMethodids" data-testid="disposalMethodId" name="disposalMethodId">        
            <div class="mat-select-search-container" (click)="$event.stopPropagation()">
              <input #dmSearchInput matInput placeholder="Search Disposal Method..." (input)="filterDisposalMethod($event)"
                      class="mat-select-search-input" aria-label="Search Disposal Method" (keydown)="$event.stopPropagation();" />
              <mat-icon class="mat-select-search-icon">search</mat-icon>
            </div>
            <mat-option [value]="null">-Select Disposal Method-</mat-option>
            @for (dm of filteredDisposalMethods; track dm.id) {
            <mat-option [value]="dm.id">{{ dm.disposalMethod }}</mat-option>
            }
          </mat-select>
        </mat-form-field>    
    </div>
    <div class="form-grid-row">
        <!-- Oracle Account Number -->
        <mat-form-field appearance="outline">
          <mat-label>Oracle Account Number</mat-label>
          <input matInput
                formControlName="oracleAccountNumber"
                data-testId="oracleAccountNumber" type="text"  (input)="roundOff($event, 99999999, 0, 2, 'oracleAccountNumber')" />
        </mat-form-field>

        <!-- Oracle Site Number -->
        <mat-form-field appearance="outline">
          <mat-label>Oracle Site Number</mat-label>
          <input matInput type="text"
                formControlName="oracleSiteNumber"
                data-testId="oracleSiteNumber" maxlength="10" />
        </mat-form-field>
    </div>
    <!-- VR SPECIFIC FIELDS -->
    @if (isVRSelected) {
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Normal CHGP Efficiency</mat-label>
        <input matInput type="text" required formControlName="normalCHGPEfficiency" placeholder="Enter Normal CHGP Efficiency" (input)="roundOff($event, 99, 3, 0, 'normalCHGPEfficiency')" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Conversion BTU</mat-label>
        <input matInput type="text" required formControlName="conversionBTU" placeholder="Enter Conversion BTU" (input)="roundOff($event, 9999, 0, 0, 'conversionBTU')" />
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>CH4 Low Heating</mat-label>
        <input matInput type="text" required formControlName="ch4LowHeatingvalue" placeholder="Enter CH4 Low Heating" (input)="roundOff($event, 9999, 0, 0, 'ch4LowHeatingvalue')" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Chp Capacity</mat-label>
        <input matInput type="text" required formControlName="chpCapacity" placeholder="Enter Chp Capacity" (input)="roundOff($event, 9999, 0, 0, 'chpCapacity')" />
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>SSO Goal</mat-label>
        <input matInput type="text" required formControlName="ssoGoal" placeholder="Enter SSO Goal" (input)="roundOff($event, 9999, 0, 0, 'ssoGoal')" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Volume</mat-label>
        <input matInput type="text" required formControlName="volume" placeholder="Enter Volume" (input)="roundOff($event, 9999, 4, 0, 'volume')" />
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Manure Goal</mat-label>
        <input matInput type="text" required formControlName="manureGoal" placeholder="Enter Manure Goal" (input)="roundOff($event, 999, 2, 0, 'manureGoal')" />
      </mat-form-field>
      </div>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="form-actions">
    <button mat-raised-button
            color="primary"
            type="button"
            (click)="onCancel()">
      Cancel
    </button>
    @if(canSave){
      <button mat-raised-button
              color="primary"
              mat-primary
              type="submit"
              (click)="onSubmit()">
        Save
      </button>
    }
  </div>
</mat-dialog-actions> 
